import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import formatFieldsObjToSnake from 'Shared/util/formatFieldsObjToSnake';

import Page from 'Components/Page';
import TabOpen from './components/TabOpen';
import TabPaid from './components/TabPaid';
import withAuthentication from 'Components/withAuthentication';
import ReactGA from 'Shared/analytics';

const Invoices = ({ profileData, indicationTab }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <>
      <Route path="/customer/invoices/" exact render={() => <Redirect to="/customer/invoices/open/" />} />
      <Switch>
        <Route path="/customer/invoices/open/" component={TabOpen} />
        <Route path="/customer/invoices/paid/" component={TabPaid} />
      </Switch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.replace(`/customer/invoices/${tabClicked}/`);
        ReactGA.pageview(`/customer/invoice/${tabClicked}/`, 'Invoices' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Invoices',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'open',
                label: 'OPEN',
              },
              {
                id: 'paid',
                label: 'PAID',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
            indicationTabs: indicationTab && formatFieldsObjToSnake(indicationTab.invoiceMetaInfo),
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'invoices',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Invoices);
